import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencil.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/Delete.svg';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { ButtonClassNames } from '../../../../models/Common';

interface EmailProps {
  handleEditEmail: () => void;
  handleAddNewEmail: (message: string) => void;
  handleDeleteEmail: () => void;
  handleResendEmail: () => void;
  value: string | number | null;
  awaitingConfirm: boolean;
  isResendDisabled: boolean;
}

export const Email: FC<EmailProps> = ({
  handleAddNewEmail,
  value,
  awaitingConfirm,
  handleEditEmail,
  handleDeleteEmail,
  handleResendEmail,
  isResendDisabled,
}) => {
  const { t } = useTranslation();
  if (value === null) {
    return (
      <TextButton
        label={`${t('buttons.addEmail')} +`}
        handleClick={() => handleAddNewEmail(`${t('buttons.addEmail')} +`)}
        className={TextButtonClassNames.PrimaryActive}
      />
    );
  }

  return (
    <>
      <div className="account__info__item__email">
        <p className="account__info__item__email__description">{value}</p>
        <div className="account__info__item__email__buttons">
          <CustomMUIButton
            label={<EditPencilIcon />}
            handleClick={handleEditEmail}
            className={ButtonClassNames.IconFulfilled}
            tooltipText={`${t('buttons.change')}`}
          />
          <CustomMUIButton
            label={<DeleteIcon />}
            handleClick={handleDeleteEmail}
            className={ButtonClassNames.IconFulfilled}
            tooltipText={`${t('buttons.delete')}`}
          />
        </div>
      </div>
      {awaitingConfirm && (
        <TextButton
          label={`${t('buttons.sendAgain')}`}
          handleClick={handleResendEmail}
          className={TextButtonClassNames.PrimaryActive}
          isDisabled={isResendDisabled}
        />
      )}
    </>
  );
};
